import NavLink from './NavLink'
import './NavLink.scss'

export default NavLink
